export default __webpack_public_path__ + "static/media/640_business02-nl-mobile.9cb93a31.png";